import { isPJ } from "../../../helper_functions";
import { vanishElement } from "../../vanish_element";

export function setPhoneNumberRequired(isRequired, { isClientPj, phoneNumberInput }) {
  if (isClientPj()) {
    return;
  }
  const label = document.querySelector(`label[for="${phoneNumberInput.id}"]`);
  if (isRequired) {
    phoneNumberInput.setAttribute("required", true);
    phoneNumberInput.setAttribute("pattern", "\\(\\d{2}\\)\\s\\d{5}-\\d{4}");
    phoneNumberInput.setAttribute("title", "Número de telefone deve ser no formato (99) 99999-9999");
    label.classList.add("required");
    label.querySelector("small").classList.add("inline-zero-width");
  } else {
    phoneNumberInput.removeAttribute("required");
    phoneNumberInput.removeAttribute("pattern");
    phoneNumberInput.removeAttribute("title");
    label.classList.remove("required");
    label.querySelector("small").classList.remove("inline-zero-width");
  }
}

export function setupClientForm () {
  // Defines PF or PJ from backend
  const clientTypeInput = document.getElementById("client_payment_client_type");

  // form
  const formElement = document.getElementById("client_payment_form");
  const nameInput = document.getElementById("client_payment_name");
  const emailInput = document.getElementById("client_payment_email");
  const documentInput = document.getElementById("client_payment_document");
  const isForeignerInput = document.getElementById("is_foreigner");
  const phoneNumberInput = document.getElementById(
    "client_payment_phone_number"
  );
  const whatsappAcceptElement = document.getElementById("whatsapp_checkbox");
  // CNPJ registration
  const stateRegistrationInput = formElement?.querySelector(
    "input#client_payment_state_registration"
  );
  const municipalRegistrationInput = formElement?.querySelector(
    "input#client_payment_municipal_registration"
  );

  const zipCodeInput = document.getElementById("client_payment_zip_code");
  const clientCreatedAtHiddenInput = document.getElementById("client_created_at");

  function isClientPj () {
    return isPJ(clientTypeInput.value);
  }

  return {
    isClientPj,
    getClientInformation () {
      return {
        client_name: nameInput.value,
        client_email: emailInput.value,
        client_document: documentInput.value,
        client_phone_number: phoneNumberInput.value,
        client_zip_code: zipCodeInput?.value ?? "",
        client_created_at: clientCreatedAtHiddenInput.value,
        client_whatsapp_accept: whatsappAcceptElement.checked,
        client_state_registration: stateRegistrationInput?.value.trim() ?? "",
        client_municipal_registration: municipalRegistrationInput?.value.trim() ?? ""
      };
    },
    getFormData () {
      const pj = isClientPj();
      const base = {
        name: nameInput.value,
        email: emailInput.value,
        is_pj: pj,
        is_foreigner: false,
        document: documentInput.value,
        phone_number: phoneNumberInput.value,
        zip_code: zipCodeInput?.value ?? "",
        whatsapp_accept: whatsappAcceptElement.checked,
        created_at: clientCreatedAtHiddenInput.value
      };

      return pj
        ? {
            ...base,
            state_registration: stateRegistrationInput.value,
            municipalRegistrationInput: municipalRegistrationInput.value
          }
        : {
            ...base,
            is_foreigner: isForeignerInput?.checked
          };
    },
    setForeignerCheckboxHidden (isHidden = false) {
      if (isClientPj()) {
        return;
      }
      vanishElement(isForeignerInput.parentElement, isHidden);
    },
    setPersonalDocumentRequired (isRequired = false) {
      if (isClientPj()) {
        return;
      }
      // CPF is required for every payment method (g-722); estrangeiro checkbox
      // visibility is controlled separately via setForeignerCheckboxHidden.
      const label = document.querySelector("label[for=client_payment_document]");
      const error = document.querySelector("#document_validation");
      if (isRequired) {
        documentInput.setAttribute("required", true);
        label?.classList.add("required");
        label?.querySelector("small")?.classList.add("inline-zero-width");
      } else {
        documentInput.removeAttribute("required");
        label?.classList.remove("required");
        label?.querySelector("small")?.classList.remove("inline-zero-width");
        error?.classList.add("hidden");
      }
    },
    setPersonalPhoneNumberRequired (isRequired = false) {
      return setPhoneNumberRequired(isRequired, { isClientPj, phoneNumberInput });
    },
    inputs: {
      clientTypeInput,
      nameInput,
      emailInput,
      documentInput,
      isForeignerInput,
      phoneNumberInput,
      zipCodeInput,
      whatsappAcceptElement,
      stateRegistrationInput,
      municipalRegistrationInput
    }
  };
}
